import { clsx } from "clsx";

/**
 * Utility function to merge classes similar to shadcn/ui's cn function
 */
export function cn(...inputs) {
  return clsx(inputs);
}

/**
 * Shadcn/ui inspired color palette and styling constants
 */
export const chatStyles = {
  // Base colors
  background: '#ffffff',
  foreground: '#0f172a',
  muted: '#f8fafc',
  mutedForeground: '#64748b',
  border: '#e2e8f0',
  input: '#f8fafc',
  
  // Primary colors
  primary: '#0f172a',
  primaryForeground: '#f8fafc',
  
  // Secondary colors
  secondary: '#f1f5f9',
  secondaryForeground: '#0f172a',
  
  // Accent colors
  accent: '#f1f5f9',
  accentForeground: '#0f172a',
  
  // Destructive colors
  destructive: '#ef4444',
  destructiveForeground: '#fef2f2',
  
  // Border radius
  radius: '6px',
  
  // Shadows
  shadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  shadowLg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
}

/**
 * Animation keyframes for typing indicator
 */
export const typingAnimation = {
  '@keyframes typing': {
    '0%, 60%, 100%': {
      transform: 'translateY(0px)',
      opacity: '0.5'
    },
    '30%': {
      transform: 'translateY(-10px)',
      opacity: '1'
    }
  }
};